//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Check-in Requirements for Group Scheduling */
export const AttendanceRecordRequiredForCheckIn = {
    /** Person doesn't need to be scheduled */
    ScheduleNotRequired: 0,

    /** Person doesn't need to be scheduled, but pre-select group if they are scheduled. */
    PreSelect: 1,

    /** Person cannot check into group unless they have been scheduled  */
    ScheduleRequired: 2
} as const;

/** Check-in Requirements for Group Scheduling */
export const AttendanceRecordRequiredForCheckInDescription: Record<number, string> = {
    0: "Schedule Not Required",

    1: "Pre-select Group if Scheduled",

    2: "Schedule Required"
};

/** Check-in Requirements for Group Scheduling */
export type AttendanceRecordRequiredForCheckIn = typeof AttendanceRecordRequiredForCheckIn[keyof typeof AttendanceRecordRequiredForCheckIn];
